import { LoadingContainer } from 'components/loadingContainer'
import { useImageById } from 'hooks/user/useImage/useImageById'
import { useEffect, useState } from 'react'

import { Image, ImageContainer, ImageOverlay, Title } from './header.style'

interface Props {
    title: string
    imageId: string
}

export const Header = ({ title, imageId }: Props) => {
    const { data, isLoading, error } = useImageById(imageId)
    const [fontSize, setFontSize] = useState(24)

    useEffect(() => {
        const titleLength = title.length
        if (titleLength < 21) {
            setFontSize(48)
        } else if (titleLength < 31) {
            setFontSize(36)
        } else if (titleLength < 41) {
            setFontSize(24)
        } else {
            setFontSize(16)
        }
    }, [title])

    return (
        <ImageContainer>
            <LoadingContainer isLoading={isLoading} error={error}>
                {data && <Image alt={`Borítókép_${title}`} src={data.image_url} />}
                <ImageOverlay>
                    <Title fontSize={fontSize}>{title}</Title>
                </ImageOverlay>
            </LoadingContainer>
        </ImageContainer>
    )
}
